export const device = (() => {
  const ua = navigator.userAgent;
  const isAndroid = /Android\s+([\d.]+)/.test(ua);
  const isIos = /(?:iPad|iPhone).*OS\s([\d_]+)/.test(ua) && !isAndroid;
  const isWeixin = /micromessenger/.test(ua.toLowerCase());
  const isQQ = /QQBrowser/.test(ua);
  const isChrome = ua.toLowerCase().indexOf('chrome') > -1;
  const isSafari = ua.toLowerCase().indexOf('safari') > -1;
  const isFirfox = ua.toLowerCase().indexOf('firefox') > -1;
  const isIE = ua.toLowerCase().indexOf('msie') > -1 || ua.toLowerCase().indexOf('trident') > -1;
  const isWindows = ua.toLowerCase().indexOf('windows') > -1;
  const isMac = ua.toLowerCase().indexOf('macintosh') > -1;
  const isDingTalk = ua.toLowerCase().indexOf('dingtalk') > -1;
  return {
    isAndroid,
    isIos,
    isIpad: (/(?:iPad).*OS\s([\d_]+)/.test(ua) && !isAndroid) || (isSafari && !navigator.maxTouchPoints),
    isMobile: isAndroid || isIos,
    isWeixin,
    isQQ,
    isChrome,
    isSafari,
    isIE,
    isFirfox,
    isWindows,
    isMac,
    isDingTalk,
  };
})();
